<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({ buttons: Array });

const buttons = computed(() => props.buttons.filter(e => e.visible));
</script>

<template>
  <div class="h-6 flex justify-center">
    <div v-for="(item, index) in buttons" :key="index" class="flex">
      <el-button
        type="text"
        class="py-0 border-0 text-xs whitespace-normal custom-blue"
        @click="item.onClick"
      >
        {{ $t(item.text) }}
      </el-button>
      <div v-if="index < buttons.length - 1" class="split-line"></div>
    </div>
  </div>
</template>

<style scoped lang="less">
.split-line {
  margin: auto 10px;
  height: 10px;
  border-right: 1px solid #dfdfdf;
}

.custom-blue {
  color: #0067d1 !important;

  &:active {
    color: #004ea8 !important;
  }
}
</style>
